<template>
  <div class="course-cover-uploader"
    id="fine-uploader"
  >
  </div>
</template>
<script>

import { mapGetters } from 'vuex'
export default {
  name: 'UploadImg',
  data() {
    return {
      loading: false,
      imageUrl: '',
    };
  },
  computed: {
    ...mapGetters('userInfo', ['userInfo', 'userId'])
  },
  mounted() {
    this.handleUpdate()
  },
  methods: {
    handleUpdate() {
      const self = this
      $('#fine-uploader').Ableuploader({
        targetId: "fine-uploader", //为按钮目标标签ID
        appName: "ablecommons",//对应应用名称
        userId: self.userInfo.userId, //填写用户ID
        userName: self.userInfo.name,
        modelName: "demo", //模块名称
        // autoConvert: "true",//true为自动转换，false或者不配置为不自动转换(上传需要自带文档转换,Flex上传不需要自带转换.)
        buttonWidth: "160", //IE789下设置此按钮宽度生效
        buttonHeight: "90",
        showProgress: "false", //是否显示任务栏进度条
        multipleUpload: "false",
        buttonText: "",
        image: {},//图片尺寸大小限制 如：{maxHeight: 300, maxWidth: 300}
        buttonClass: "btn-spoc-course-upload",
        // buttonTextStyle: "{ font-size: 14px; color: #969799; height:90px;width: 160px;}", // 按钮文字样式定义
        allowSuffix: "jpg|jpeg|png|bmp|gif|webp",//自定义限制后缀 demo: image-->"jpg|png|bmp" video-->"flv|mp4|mp3"
        // videoConvert: "true",
        fileSizeLimit: 5242880, //5MB,文件大小限制 0代表无限制 字节B
        fileItemLimit: 1,
        // watermark: false, //视频转码文件是否添加水印 true添加false不添加
        //一次允许上传的个数，默认为0不限制
        host: "//base1.zhihuishu.com/able-commons/",
        callbacks: {
          onFileDialogStart: function (tid) {

          },
          onUpload: function (id, fileName) {
            self.$emit('updateUpload', {loading: true})
          },
          onComplete: function (id, fileName, responseJSON = {}) {
            //上传完成返回事件
            if (responseJSON.code == 200) {
              let { filePath } = responseJSON.data || {}
              self.imageUrl = filePath
              self.$emit('updateUpload', {loading: false, imageUrl: self.imageUrl})
            } else {
              this.$message.error('上传失败')
              self.$emit('updateUpload', {loading: false})
            }
          }
        },
      })
    }
  },
};
</script>
<style lang="scss" scoped>
.course-cover-uploader {
  width: 160px;
  height: 90px;
}
</style>
<style lang="scss">
.btn-spoc-course-upload{
  width: 160px;
  height: 90px;
}
</style>